import { useParams } from 'react-router-dom'
import ClientThemeForm from './ClientThemeForm'

const View = () => {
    const params = useParams()

    return (
        <ClientThemeForm
            id={parseInt(params.clientThemeId)}
            inPopup={false}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Theme updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update theme',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating theme...',
                },
            }}
        />
    )
}

export default View
